function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "decoC",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M421.69,438.09c8.91-1.27,18.57-2.46,28.17-4.06,10.73-1.79,18.33,2.44,24.04,11.27,7.33,11.34,7.16,26.96-.48,37.62-6.56,9.15-15.5,12.83-26.47,11.47-10.3-1.28-16.62-7.85-20.51-16.93-1.95-4.56-3.13-9.45-4.81-14.14-1.77-4.95-4.48-8.75-10.45-9.25-2.39-.2-4.8-1.42-6.98-2.59-1.42-.76-3.59-2.45-3.43-3.37.42-2.35,1.38-5.24,3.15-6.58,4.92-3.76,10.73-5.14,17.77-3.43h0ZM404.5,443.76c-.16.63-.31,1.25-.47,1.88,1.77.33,3.54.82,5.32.96,9.91.8,15.6,6.69,18.76,15.54,1.32,3.7,2.19,7.56,3.45,11.29,4.78,14.15,19.3,18.76,29.95,12.02,8.55-5.41,11.55-13.53,11.18-23.73-.65-18.24-19.37-31.67-38.31-22.19,16.61,9.5,25.24,19.51,22.83,27.66-11.02-24.3-29.39-30.04-52.72-23.43h0Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,443.76c23.32-6.6,41.7-.86,52.72,23.43,2.41-8.15-6.22-18.16-22.83-27.66,18.94-9.47,37.66,3.95,38.31,22.19.36,10.19-2.63,18.31-11.18,23.73-10.65,6.74-25.17,2.13-29.95-12.02-1.26-3.73-2.13-7.59-3.45-11.29-3.16-8.85-8.86-14.74-18.76-15.54-1.79-.14-3.55-.63-5.32-.96.16-.63.31-1.25.47-1.88h0Z",
    style: {
      fill: "#a65252",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoC);
export default __webpack_public_path__ + "static/media/decoC.5bda94fc9d5e88918f5653bba7b04e6a.svg";
export { ForwardRef as ReactComponent };